import * as routerHelper from '@/helpers/router.helper';

const authRoutes = {
  path: '/',
  name: 'authRoutes',
  component: () => import(/* webpackChunkName: "eHotelSuite" */ '@/views/Layout/AuthLayout.vue'),
  meta: {
    title: 'Welcome',
    documentTitle: '*login.pageTitle',
    public: true,
    guestOnly: true,
    translationKey: ['login', 'validation', 'links'],
  },
  children: [
    {
      path: '/login/:uuid([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})?',
      name: routerHelper.loginRouteName,
      meta: {
        title: 'Welcome',
        documentTitle: '*login.pageTitle',
        public: true,
        guestOnly: true,
        translationKey: ['login', 'validation', 'links'],
        shared: true, // This means this route can be used mapping master project
      },
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Cultbooking/Login.vue'),
    },
    {
      path: '/direct-login',
      name: routerHelper.directLoginRouteName,
      meta: {
        title: 'Welcome',
        documentTitle: '*login.pageTitle',
        public: true,
        guestOnly: true,
        translationKey: ['login'],
      },
      component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Cultbooking/Login.vue'),
    },
    {
      path: '/register',
      name: routerHelper.registerRouteName,
      meta: {
        title: 'Sign Up',
        documentTitle: '*signup.title',
        // sideBar: false,
        public: true,
        guestOnly: true,
        agent: false,
        shared: true, // This means this route can be used mapping master project
        translationKey: ['register', 'buttons', 'links', 'validation', 'login', 'labels', 'placeholder'],
      },
      component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/Cultbooking/Register.vue'),
    },
    {
      path: '/password/email',
      name: routerHelper.passwordEmailRouteName,
      meta: {
        title: 'Forgot Password',
        documentTitle: '*forgot-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        shared: true, // This means this route can be used mapping master project
        translationKey: ['passwordEmail'],
      },
      component: () => import(/* webpackChunkName: "forgot-password" */ '@/views/Auth/Cultbooking/ForgotPassword.vue'),
    },
    {
      path: '/password/change',
      name: routerHelper.passwordChangeRouteName,
      meta: {
        title: 'Change Password',
        documentTitle: '*change-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        shared: true, // This means this route can be used mapping master project
        translationKey: ['passwordChange'],
      },
      component: () => import(/* webpackChunkName: "change-password" */ '@/views/Auth/Cultbooking/ChangePasswordSent.vue'),
    },
    {
      path: '/password/reset',
      name: routerHelper.passwordResetRouteName,
      meta: {
        title: 'Reset Password',
        documentTitle: '*reset-pwd.title',
        public: true,
        guestOnly: true,
        agent: false,
        shared: true, // This means this route can be used mapping master project
        translationKey: ['passwordReset'],
      },
      component: () => import(/* webpackChunkName: "reset-password" */ '@/views/Auth/Cultbooking/ResetPassword.vue'),
    },
  ],
};

export default authRoutes;
